/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Fragment } from 'react'

import _ from 'lodash'

import { handleChange } from '@/Form/Functions/eventsHandling'

import getFormStatus from '@/Form/Functions/getFormStatus'

import CustomQuoteElements from '@/CustomQuote/CustomQuoteElements'

import Loader from '@Pure/Loader'

const { app, qwest } = window;

const contact_email =
{
	id: 'contact-email',
	_index: '-1',
	label: 'Votre E-mail de contact',
	required: true,
	type: 'text'
};

export default class FrontCustomQuote extends React.Component
{
	state =
	{
		form_data: { },
		status_messages: { },
		loading: false
	};

	handleElementChange = handleChange.bind(this)

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		state.form_data = { };

		if (app.state.session.login)
		{
			state.form_data = component.handleSessionChange(
			{
				return: true,
				form_data: state.form_data
			});
		}

		component.setState(
		{
			status_messages: { },
			form_data: state.form_data,

			loading: false,
			default_email_loaded: Boolean(state.form_data['custom_quote[contact-email]']),
			sent: false
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = (options) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.login || state.form_data['contact-email'])
		{
			return;
		}

		let form_data = options?.form_data || state.form_data;

		let session_email = app.state.session.login;

		if (app.state.session.permissions.title === 'EC')
		{
			session_email = app.state.session.EC.email;
		}

		form_data['custom_quote[contact-email]'] = session_email;

		if (options.return === true)
		{
			return form_data;
		}

		component.setState(
		{
			form_data: form_data,

			default_email_loaded: true,
			loading: false
		});
	}

	sendQuote = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		e.target.blur();

		if (state.loading === true) return;

		let quote = _.cloneDeep(props.quote);

		quote.elements.push(contact_email);

		qwest.post('/custom-quote/send', _.merge(state.form_data, { quote: quote }))
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				info: response.info,
				error: response.error,
				warning: response.warning,
				sent: [true, 'true'].includes(response.success)
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState(
			{
				loading: false,
				info: response.info,
				error: response.error,
				warning: response.warning,
				status_messages: _.merge(state.status_messages, response.fields)
			});

			app.ajaxRedirectLogin(response);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader, send_btn, status = getFormStatus(state);

		if (state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['white', 'bg-primary', 'CustomQuoteRequest'] } />
			);
		}

		if (state.sent !== true)
		{
			send_btn =
			(
				<button type="button" className="c-btn c-btn--extra u-margin-bottom-30"
					onClick={ component.sendQuote }>
					Envoyer la demande de devis
					{ loader }
				</button>
			);
		}

		let quote_elements;

		if (state.default_email_loaded === true)
		{
			quote_elements =
			(
				<CustomQuoteElements
					elements={ [contact_email].concat(props.elements || []) }
					editable={ true } onChange={ component.handleElementChange }
					form_data={ state.form_data } status={ state.status_messages }
				/>
			);
		}

		return (
			<>
				{ quote_elements }

				{ status }

				{ send_btn }
			</>
		);
	}
}